//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from "vuex";
import { date } from "quasar";
//import wrapCsvValue from "../../mixins/wrapCsvValue";
export default {
  data() {
    return {
      pagination: {
        rowsPerPage: 30, // current rows per page being displayed
        sortBy: "id",
        descending: true,
      },
      columns: [
        {
          name: "id",
          align: "left",
          label: "Id",
          field: "id",
          sortable: true,
        },
        {
          name: "TransactionType",
          align: "left",
          label: this.$t("stock.transactionType"),
          field: "transactionTypeId",
          format: (val) => this.$t(`stock.transactionType-${val}`),
          sortable: true,
        },
        {
          name: "ProductNumber",
          align: "left",
          label: this.$t("stock.productNo"),
          field: "productNumber",
          sortable: true,
        },
        {
          name: "Product",
          align: "left",
          label: this.$t("stock.productName"),
          field: "productName",
          sortable: true,
        },
        {
          name: "Warehouse",
          align: "left",
          label: this.$t("stock.warehouse"),
          field: "warehouseName",
          sortable: true,
        },
        {
          name: "Location",
          align: "left",
          label: this.$t("stock.location"),
          field: "locationName",
          sortable: true,
        },
        {
          name: "Quantity",
          align: "right",
          label: this.$t("stock.transactionQuantity"),
          field: "transactionQuantity",
          sortable: true,
        },
        {
          name: "NewQuantity",
          align: "right",
          label: this.$t("stock.locationNewQuantity"),
          field: "locationNewQuantity",
          sortable: true,
        },
        {
          name: "Comment",
          align: "left",
          label: this.$t("stock.comment"),
          field: "comment",
          sortable: true,
        },
        {
          name: "CreatedBy",
          align: "left",
          label: this.$t("common.createdBy"),
          field: "createdByDisplayName",
          sortable: true,
        },
        {
          name: "Created",
          align: "left",
          label: this.$t("common.created"),
          format: (val) => date.formatDate(val, "DD-MM-YYYY"),
          field: "created",
          sortable: true,
        },
      ],
      filter: "",
      Transactions: [],
    };
  },
  async mounted() {
    await this.refresh();
  },

  methods: {
    ...mapActions("main", ["getStockTransactions"]),

    async refresh() {
      this.Transactions = [];
      const notif = this.$q.notify({
        type: "ongoing",
        message: "Laster data...",
      });

      this.Transactions = await this.getStockTransactions();

      setTimeout(() => {
        notif();
      }, 500);
    },
  },
};
